// extracted by mini-css-extract-plugin
export var completionBody = "_lm-2";
export var completionCard = "_lm-0";
export var completionFooter = "_lm-3";
export var completionTitle = "_lm-1";